import React from 'react';
import SvgIcon from './SvgIcon';

/**
 * @param {FF.SvgIcon} props
 */
function DeliveryBoxFullIcon(props) {
  return (
    <SvgIcon viewBox="0 0 60 60" {...props}>
      <title>Delivery Box Full</title>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.665 16.3004L2.58708 16.2706L2.58938 16.3279L2.5 16.36V43.9952L28.2285 53.1115L28.2308 53.1458L29.8235 53.6752L57.5 44.0365V16.2706L30 6.28125L2.665 16.3004ZM9.72104 17.1346L28.1644 10.3719L29.9977 9.70271L36.2333 12.0013L16.1881 19.479L9.72104 17.1346ZM31.061 24.9377L28.9871 24.1769L25.4602 22.8798L45.5008 15.4021L51.4317 17.5196L31.061 24.9881V24.9377ZM31.1092 28.3775L54.2871 19.919V41.754L31.4002 49.7244L31.1092 28.3775ZM5.90312 41.3575L5.81833 20.8654L26.2852 28.3042L26.551 49.0323L5.90312 41.3575Z"
        />
      </g>
    </SvgIcon>
  );
}

export default DeliveryBoxFullIcon;
